
import { ActivateLicenseActions, ActivateLicenseActionTypes } from '../actions/activate-license.actions';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
}

export const initialState: State = {
  isLoaded: false,
  isLoading: false
};

export function reducer(state = initialState, action: ActivateLicenseActions): State {
  switch (action.type) {
    case ActivateLicenseActionTypes.LoadActivateLicenses:
      return state;

    default:
      return state;
  }
}
